module.exports = __webpack_public_path__ + "e8b7f1b5fc9e0fb8f29ad4ec9e681f70.png";